// extracted by mini-css-extract-plugin
export var skipAnimation = "_t-0";